import React, { useState, useEffect } from "react";
import { TextStory, LiveBlogStory, ListicleStory, PhotoStory, VideoStory, PremiumStory } from "./index";
import { AdPlaceholder } from "../../arrow/components/Atoms/AdPlaceholder";
import { object, func } from "prop-types";
import { ConferencePage } from "../pages/ConferencePage";

// Template configuration map
const TEMPLATE_MAP = {
  "text": { component: TextStory, includeAds: true },
  "video": { component: VideoStory, includeAds: true },
  "photo": { component: PhotoStory, includeAds: true },
  "listicle": { component: ListicleStory, includeAds: true },
  "live-blog": { component: LiveBlogStory, includeAds: true },
  "premium-story-template": { component: PremiumStory, includeAds: false },
  "workshop": { component: ConferencePage, includeAds: true },
  "session": { component: ConferencePage, includeAds: true },
  "conference": { component: ConferencePage, includeAds: true },
};

// Default template
const DEFAULT_TEMPLATE = { component: TextStory, includeAds: true };

// Ad placeholder component
const AD_PLACEHOLDER = <AdPlaceholder height="250px" width="300px" />;

function StoryWrapper({
  isATGlobal,
  story,
  config,
  initAccessType,
  checkAccess,
  serverHasAccess = true,
  subscriptionPlans = [],
  initRazorPayPayment,
  validateCoupon,
  getSubscriptionForUser,
  accessTypeBkIntegrationId,
  member,
  hasUserPurchasedStory = false,
  isPPACheckComplete = true,
}) {
  const [hasAccess, setHasAccess] = useState(serverHasAccess !== undefined ? serverHasAccess : true);
  const storyTemplate = story["story-template"];

  // Check if this is a PPA story (premium template with subscription plans)
  const isPremiumStoryTemplate = storyTemplate === "premium-story-template";
  const isPPAStory = isPremiumStoryTemplate && subscriptionPlans.length > 0;

  const adWidget = () => AD_PLACEHOLDER;

  const templateConfig = {
    templateType: "default",
    showSection: true,
    publishedDetails: {
      enablePublishedTime: true,
      enableUpdatedTime: true,
      showReadTime: true,
    },
  };

  useEffect(() => {
    // Only check AccessType if we don't already have server-provided access info
    if (serverHasAccess === undefined && initAccessType && checkAccess) {
      initAccessType(() => {
        checkAccess(story.id).then((res) => {
          const { granted } = res[story.id];
          setHasAccess(granted);
        });
      });
    }
  }, [isATGlobal, serverHasAccess]);

  // Get template configuration
  const templateEntry = TEMPLATE_MAP[storyTemplate] || DEFAULT_TEMPLATE;
  const StoryComponent = templateEntry.component;

  // Common props for all templates
  const commonProps = {
    story,
    config: { ...config, ...templateConfig },
    hasAccess,
    subscriptionPlans,
    initRazorPayPayment,
    validateCoupon,
    getSubscriptionForUser,
    accessTypeBkIntegrationId,
    member,
    isPPAStory,
    hasUserPurchasedStory,
    isPPACheckComplete,
  };

  // Ad props (only for templates that include ads)
  const adProps = templateEntry.includeAds ? {
    adWidget,
    adPlaceholder: AD_PLACEHOLDER,
  } : {};

  return <StoryComponent {...commonProps} {...adProps} />;
}

StoryWrapper.propTypes = {
  isATGlobal: func,
  story: object,
  config: object,
  initAccessType: func,
  checkAccess: func,
};

export default React.memo(StoryWrapper);
